import { AppDomainConfig } from "../../envConfig";
import { IndustryEnum } from "../../types/api-schema";

import colors from "./colors";
import iconCategories from "./icons.json";

const config: Partial<AppDomainConfig> = {
  domains: ["io"],
  font: "18px  monospace, serif",
  iconCategories,
  id: "io",
  name: "IO",
  settings: {
    stops_api_prefagencies: "db,sbb",
  },
  slug: "mapsetio",
  ...colors,
  industry: IndustryEnum.Transport,
};

export default config;
